import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadingStrategy, Router } from '@angular/router';
import { LoginComponent } from './views/login/login.component';
import { LandingComponent } from './views/landing-page/landing.component';
import { SearchpageComponent } from './views/searchpage/searchpage.component';
import { UnauthorizedComponent } from './views/unauthorized/unauthorized.component';
import { AuthGuard } from './auth/auth.guard';
import { AdminGuard } from './auth/admin.guard';
import { LoginGuard } from './auth/login.guard';
import { AppPreloadingStrategy } from './app-preloading-strategy';
import { QuestionExportComponent } from './question-export/question-export.component';
import { TemplatesComponent } from './views/templates/templates.component';
import { SkillRepoEmployeesComponent } from './views/skill-repo-employees/skill-repo-employees.component';
import { SkillRepositoryComponent } from './views/skill-repository/skill-repository.component';
import { EmployeeDetailsComponent } from './views/employee-details/employee-details.component';
import { AddRolesComponent } from './views/add-roles/add-roles.component';
import { RoleGuardGuard } from './auth/role-guard.guard';
import { DataUploadComponent } from './components/dataupload/dataupload.component';
import { EmployeeDataTableComponent } from './views/employee-data-table/employee-data-table.component';
import { TemplateDocsComponent } from './views/template-docs/template-docs.component';
import { MockupsComponent } from './mockups/mockups.component';
import { EmployeeComponent } from './employee/employee.component';
import { Customer360DashboardComponent } from './components/customer-360/customer360-dashboard/customer360-dashboard.component';
import { CustomerDetailsComponent } from './components/customer-360/customer-details/customer-details/customer-details.component';
import { ProjectDetailComponent } from './views/projects/project-detail/project-detail.component';
import { IctsearchpageComponent } from './views/ictsearchpage/ictsearchpage.component';
import { AddPreferancesComponent } from './views/add-preferances/add-preferances.component';
import { ProjectTechstackComponent } from './project-techstack/project-techstack.component';
import { TimeStampComponent } from './views/time-stamp/time-stamp.component';
import { FieldMissingEmployeesComponent } from './views/field-missing-employees/field-missing-employees.component';
import { LoginIssueComponent } from './views/login-issue/login-issue.component';
import { ProgramDescriptionComponent } from './views/employee/employee-career-program/program-description/program-description.component';
import { EmployeeCareerProgramComponent } from './views/employee/employee-career-program/employee-career-program.component';
import { PartnershipGridComponent } from './views/competencies/partnership-grid/partnership-grid.component';
import { PartnershipCreationComponentComponent } from './views/competencies/competency/partnership-creation-component/partnership-creation-component.component';
import { ProjectDataTableComponent } from './views/competencies/project-data-table/project-data-table.component';
import { UserRoles } from './enums/userRoles.enum';
import { IctProjectDetailComponent } from './views/projects/ict-project-detail/ict-project-detail.component';
import { ProjectDashboardComponent } from './views/projects/project-dashboard/project-dashboard.component';
import { ProjectsListComponent } from './views/projects/projects-list/projects-list.component';
import { OrganizationalComplianceComponent } from './views/organizational-compliance/organizational-compliance.component';
import { OrganizationalComplianceCreationComponent } from './views/organizational-compliance-creation/organizational-compliance-creation.component';
import { EmployeeCareerPathComponent } from './views/employee/employee-career-path/employee-career-path.component';
import { ProgramCatalogueComponent } from './views/employee/program-catalogue/program-catalogue.component';
import { TeamProgramComponent } from './views/Dashboard/team-program/team-program.component';
import { QuestionsTableComponent } from './views/Audit/questions-table/questions-table.component';
import { AuditorDetailsComponent } from './views/Audit/creation/auditor-details/auditor-details.component';
import { QuestionMasterComponent } from './views/Audit/question-master/question-master/question-master.component';
import { ProjectDisplayComponent } from './views/Audit/project-display/project-display/project-display.component';
import { ProjectListingComponent } from './views/Audit/project-list/project-listing.component';
import { ProjectSettingsComponent } from './views/Audit/settings/project-settings.component';
import { ProjectOverviewComponent } from './views/Audit/project-overview/project-overview.component';
import { GenAiMainComponent } from './views/GenAI-POC/gen-ai-main/gen-ai-main.component';
import { TechnologyQuestionsComponent } from './views/Audit/question-master/technology-questions/technology-questions.component';
import { SelectCategoriesComponent } from './views/Audit/creation/auditor-details/select-categories/select-categories.component';
import { PeopleStrongDataUploadComponent } from './views/time-stamp/people-strong-data-upload/people-strong-data-upload.component';
import { MaintenancePageComponent } from './views/maintenance-page/maintenance-page.component';
import { AccessEmployeeDashboardComponent } from './employee/access-employee-dashboard/access-employee-dashboard.component';
import { DashboardComponent } from './views/Dashboard/dashboard/dashboard.component';
import { ReminderAndEscalationComponent } from './reminder-and-escalation/reminder-and-escalation.component';
const routes: Routes = [
  { path: 'Dashboard', loadChildren: () => import('./views/Dashboard/dashboard.module').then(m => m.DashboardModule) },
  { path: 'Home/Dashboard', loadChildren: () => import('./views/Dashboard/dashboard.module').then(m => m.DashboardModule) },
  {
    path: 'Home/Dashboard/Employee Impersonation/:empId',
    component: DashboardComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      breadcrumb: 'Home/Dashboard/Employee Impersonation/:empId',
     // roles: ['SuperAdmin', 'Admin', 'Leadership', 'Skill.User', 'CompetencyLeader', 'SubCompetencyLeader'],
    }
  },
  {
    path: 'Home/Executive Dashboard',
    loadChildren: () => import('./views/executive-dashboard/executive-dashboard.module').then(m => m.ExecutiveDashboardModule),
    canActivate: [AuthGuard, RoleGuardGuard],
    data: { roles: ['SuperAdmin', 'Admin', 'Leadership'] }
  },
  { path: 'Home/employee-career', loadChildren: () => import('./views/employee/employee-career.module').then(m => m.EmployeeCareerModule) },
  {
    path: 'Home/Proposal Repository',
    loadChildren: () => import('./views/proposals/proposals.module').then(m => m.ProposalsModule),
    canActivate: [AuthGuard, RoleGuardGuard],
    data: { roles: ['SuperAdmin', 'Admin', 'Leadership'] }
  },

  { path: '', redirectTo: '/login', pathMatch: 'full' },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [LoginGuard]
  },
  {
    path: 'Home/Dashboard/Employee Impersonation',
    component: AccessEmployeeDashboardComponent,
    data: {
      breadcrumb: 'Home/Dashboard/Employee Impersonation',
     // roles: ['SuperAdmin', 'Admin', 'Leadership','Skill.User', 'CompetencyLeader', 'SubCompetencyLeader'],
      preload: true
    },
  },
  {
    path: 'login-issue',
    component: LoginIssueComponent,
  },
  {
    path: 'Home/Skill Repository',
    component: SkillRepositoryComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      breadcrumb: 'Home/Skill Repository',
      roles: ['SuperAdmin', 'Admin', 'Leadership', 'CompetencyLeader', 'SubCompetencyLeader'],
      preload: true
    },
  },
  {
    path: 'Home/skill_repo',
    component: SkillRepositoryComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      breadcrumb: 'Home/Skill Repository',
      roles: ['SuperAdmin', 'Admin', 'Leadership', 'CompetencyLeader', 'SubCompetencyLeader'],
      preload: true
    },
  },
  {
    path: ':competency/partnership-grid',
    component: PartnershipGridComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      breadcrumb: 'Home/CMF Portal/:competency/Partnership',
      roles: ['SuperAdmin', 'Admin', 'Leadership', 'CompetencyLeader', 'SubCompetencyLeader'],
      preload: true
    },
  },
  {
    path: 'Home/Add-partnership',
    component: PartnershipCreationComponentComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', 'CompetencyLeader', 'SubCompetencyLeader'],
      preload: true
    },
  },
  {
    path: `Home/Skill Repository/:competency`,
    component: SkillRepoEmployeesComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      breadcrumb: `Home/Skill Repository/:competency`,
      roles: ['SuperAdmin', 'Admin', 'Leadership', 'CompetencyLeader', 'SubCompetencyLeader'],
      preload: true
    }
  },
  {
    path: `Home/Skill Repository/:competency/:name/Employee Details/:EmployeeId`,
    component: EmployeeDetailsComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      breadcrumb: `Home/Skill Repository/:competency/:name/Employee Details`,
      roles: ['SuperAdmin', 'Admin', 'Leadership', 'CompetencyLeader', 'SubCompetencyLeader'],
      preload: true
    }

  },
  {
    path: 'Employee-details/:EmployeeId',
    component: EmployeeDetailsComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', 'CompetencyLeader', 'SubCompetencyLeader', 'Skill.User'],
      preload: true,
      breadcrumb: 'Home/Dashboard/Employee Details'
    }
  },
  {
    path: `Home/Skill Repository/:competency/:name/:EmployeeId`,
    component: SkillRepoEmployeesComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      breadcrumb: `Home/Skill Repository/:competency/:name`,
      roles: ['SuperAdmin', 'Admin', 'Leadership', 'CompetencyLeader', 'SubCompetencyLeader'],
      preload: true
    }
  },
  {
    path: `Home/Skill Repository/:competency/:name`,
    component: SkillRepoEmployeesComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      breadcrumb: `Home/Skill Repository/:competency/:name`,
      roles: ['SuperAdmin', 'Admin', 'Leadership', 'CompetencyLeader', 'SubCompetencyLeader'],
      preload: true
    }
  },
  {
    path: `Home/Customer360`,
    component: Customer360DashboardComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      breadcrumb: `Home/Customer360`,
      roles: ['SuperAdmin', 'Admin'],
      preload: true
    }
  },
  {
    path: `Home/Customer360/Centene`,
    component: CustomerDetailsComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      breadcrumb: `Home/Customer360/Centene`,
      roles: ['SuperAdmin', 'Admin'],
      preload: true
    }
  },

  {
    path: 'Home/Skill Repository/:competencyId/:subcompetencyId/:filter/:EmployeeId',
    component: SkillRepoEmployeesComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      breadcrumb: 'Home/Skill Repository/:competency',
      roles: ['SuperAdmin', 'Admin', 'Leadership', 'CompetencyLeader', 'SubCompetencyLeader'],
      preload: true
    }
  },
  {
    path: `Home/skill_repo/:competency/Employee Details/:EmployeeId`,
    component: EmployeeDetailsComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', 'CompetencyLeader', 'SubCompetencyLeader'],
      preload: true,
      breadcrumb: 'Home/Skill Repository/:competency/Employee Details'
    }
  },
  {
    path: `Home/skill_repo/Employee Details/:EmployeeId`,
    component: EmployeeDetailsComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', 'CompetencyLeader', 'SubCompetencyLeader'],
      preload: true,
      breadcrumb: 'Home/Skill Repository/Employee Details'
    }
  },
  {
    path: `Home/skill_repo/:competency`,
    component: SkillRepoEmployeesComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', 'CompetencyLeader', 'SubCompetencyLeader'],
      preload: true,
      breadcrumb: 'Home/skill_repo/:competency'
    }
  },
  {
    path: `Home/skill-repo/:competency/Employee-details/:EmployeeId`,
    component: SkillRepoEmployeesComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', 'CompetencyLeader', 'SubCompetencyLeader'],
      preload: true,
      breadcrumb: 'Home/skill_repo/:competency'
    }
  },
  {
    path: `Home/skill-repo/:competency/:subcompetency/:widgets/:filter`,
    component: SkillRepoEmployeesComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', 'CompetencyLeader', 'SubCompetencyLeader'],
      preload: true,
      breadcrumb: 'Home/skill_repo/:competency'
    }
  },
  {
    path: `skill-repo/:competency/:subcompetency/:widgets/:filter`,
    component: SkillRepoEmployeesComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', 'CompetencyLeader', 'SubCompetencyLeader'],
      preload: true,
      breadcrumb: 'Home/skill_repo/:competency'
    }
  },
  {
    path: `Home/skill-repo/:competency/:subcompetency/:widgets/:filter`,
    component: SkillRepoEmployeesComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', 'CompetencyLeader', 'SubCompetencyLeader'],
      preload: true,
      breadcrumb: `skill-repo/:competency/:subcompetency/:widgets/:filter`
    }
  },
  {
    path: `Home/skill-repo/:competency/:subcompetency/:widgets/:filter`,
    component: SkillRepoEmployeesComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', 'CompetencyLeader', 'SubCompetencyLeader'],
      preload: true,
      breadcrumb: `Home/skill-repo/:competency/:subcompetency/:widgets/:filter`
    }
  },

  {
    path: 'Home',
    component: LandingComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', 'CompetencyLeader', 'SubCompetencyLeader', UserRoles.ContentManager, UserRoles.Viewer, UserRoles.SuperAdmin, UserRoles.Admin],
      preload: true
    }
  },
  {
    path: 'Home/Add Roles',
    component: AddRolesComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      breadcrumb: 'Home/Add Roles',
      roles: ['SuperAdmin']
    }
  },
  {
    path: 'Home/Preferances',
    component: AddPreferancesComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      breadcrumb: 'Home/Preferences',
      roles: ['SuperAdmin']
    }
  },
  {
    path: 'Home/Reminder and Escalations',
    component: ReminderAndEscalationComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      breadcrumb: 'Home/Reminder and Escalations',
      roles: ['SuperAdmin']
    }
  },
  {
    path: 'Home/Timesheet Management',
    component: TimeStampComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      breadcrumb: 'Home/Timesheet Management',
      roles: ['SuperAdmin', 'PMORole']
    }
  },
  { path: 'Home/People Strong Timesheet Data',
    component: PeopleStrongDataUploadComponent,
    canActivate : [AuthGuard, RoleGuardGuard],
    data: {
      breadcrumb: 'Home/People Strong Timesheet Data',
      roles: ['SuperAdmin','PMORole']
    }
   },
  {
    path: 'Home/KMSPortal',
    component: SearchpageComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: [UserRoles.Viewer, UserRoles.ContentManager, UserRoles.SuperAdmin, UserRoles.Admin],
      breadcrumb: 'Home/KMS Portal',
    }
  },
  {
    path: 'Home/KMS Portal',
    component: SearchpageComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership'],
      breadcrumb: 'Home/KMS Portal',
    }
  },
  {
    path: 'Home/KMSPortal/Corporate Deck',
    component: IctsearchpageComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', UserRoles.Viewer, UserRoles.ContentManager, UserRoles.Admin, UserRoles.SuperAdmin],
      breadcrumb: 'Home/KMS Portal/Corporate Deck',
    }
  },
  {
    path: 'Home/KMSPortal/Corporate Deck/edit/:id',
    component: IctProjectDetailComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', UserRoles.Viewer, UserRoles.ContentManager, UserRoles.Admin, UserRoles.SuperAdmin],
      breadcrumb: 'Home/KMS Portal/Corporate Deck/Edit Project',
    }
  },
  {
    path: 'Home/KMS Portal/Project Content',
    component: ProjectsListComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', UserRoles.Viewer, UserRoles.ContentManager, UserRoles.Admin, UserRoles.SuperAdmin],
      breadcrumb: 'Home/KMS Portal/Project Content',
    }
  },
  {
    path: 'Home/KMSPortal/Project Content',
    component: ProjectsListComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', UserRoles.Viewer, UserRoles.ContentManager, UserRoles.Admin, UserRoles.SuperAdmin],
      breadcrumb: 'Home/KMS Portal/Project Content',
    }
  },
  {
    path: 'Home/KMSPortal/Project Content/View/:id',
    component: IctProjectDetailComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', UserRoles.Viewer, UserRoles.ContentManager, UserRoles.Admin, UserRoles.SuperAdmin],
      breadcrumb: 'Home/KMS Portal/Project Content/View Project',
    }
  },
  {
    path: 'Home/KMSPortal/Project Content/ViewProject/:id',
    component: ProjectDetailComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', UserRoles.Viewer, UserRoles.ContentManager, UserRoles.Admin, UserRoles.SuperAdmin],
      breadcrumb: 'Home/KMSPortal/Project Content/View Project',
    }
  },

  {
    path: 'Home/KMSPortal/Pending Approvals/View/:id',
    component: ProjectDetailComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', UserRoles.Viewer, UserRoles.ContentManager, UserRoles.Admin, UserRoles.SuperAdmin],
      breadcrumb: 'Home/KMS Portal/Pending Approvals/View Project',
    }
  },
  {
    path: 'Home/KMS Portal/Pending Approvals',
    component: ProjectDashboardComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', UserRoles.Viewer, UserRoles.ContentManager, UserRoles.Admin, UserRoles.SuperAdmin],
      breadcrumb: 'Home/KMS Portal/Pending Approvals',
    }
  },
  {
    path: 'Home/KMSPortal/Pending Approvals',
    component: ProjectDashboardComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', UserRoles.Viewer, UserRoles.ContentManager, UserRoles.Admin, UserRoles.SuperAdmin],
      breadcrumb: 'Home/KMS Portal/Pending Approvals',
    }
  },
  {
    path: 'Home/KMSPortal/Industry Deck/edit/:id',
    component: IctProjectDetailComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', UserRoles.Viewer, UserRoles.ContentManager, UserRoles.Admin, UserRoles.SuperAdmin],
      breadcrumb: 'Home/KMS Portal/Industry Deck/Edit Project',
    }
  },
  {
    path: 'Home/KMSPortal/Industry Deck/Add',
    component: IctProjectDetailComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', UserRoles.Viewer, UserRoles.ContentManager, UserRoles.Admin, UserRoles.SuperAdmin],
      breadcrumb: 'Home/KMS Portal/Industry Deck/Add Project',
    }
  },
  {
    path: 'Home/KMSPortal/Corporate Deck/Add',
    component: IctProjectDetailComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', UserRoles.Viewer, UserRoles.ContentManager, UserRoles.Admin, UserRoles.SuperAdmin],
      breadcrumb: 'Home/KMS Portal/Corporate Deck/Add Project',
    }
  },
  {
    path: 'Home/KMS Portal/Corporate Deck',
    component: IctsearchpageComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', UserRoles.Viewer, UserRoles.ContentManager, UserRoles.Admin, UserRoles.SuperAdmin],
      breadcrumb: 'Home/KMS Portal/Corporate Deck',
    }
  },
  {
    path: 'Home/KMSPortal/Industry Deck',
    component: IctsearchpageComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', UserRoles.Viewer, UserRoles.ContentManager, UserRoles.Admin, UserRoles.SuperAdmin],
      breadcrumb: 'Home/KMS Portal/Industry Deck',
    }
  },
  {
    path: 'Home/KMS Portal/Industry Deck',
    component: IctsearchpageComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', UserRoles.Viewer, UserRoles.ContentManager, UserRoles.Admin, UserRoles.SuperAdmin],
      breadcrumb: 'Home/KMS Portal/Industry Deck',
    }
  },
  {
    path: 'Home/KMSPortal/:speciality',
    component: SearchpageComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', UserRoles.Viewer, UserRoles.ContentManager, UserRoles.Admin, UserRoles.SuperAdmin],
      breadcrumb: 'Home/KMS Portal/:speciality',
    }
  },
  {
    path: 'Home/KMS Portal/:speciality',
    component: SearchpageComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', UserRoles.Viewer, UserRoles.ContentManager, UserRoles.Admin, UserRoles.SuperAdmin],
      breadcrumb: 'Home/KMS Portal/:speciality',
    }
  },
  {
    path: 'Home/KMSPortal/:speciality/Add',
    component: ProjectDetailComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', UserRoles.Viewer, UserRoles.ContentManager, UserRoles.Admin, UserRoles.SuperAdmin],
      breadcrumb: 'Home/KMS Portal/:speciality/Add Project',
    }
  },
  {
    path: 'Home/KMSPortal/Project Content/AddProject',
    component: ProjectDetailComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', UserRoles.Viewer, UserRoles.ContentManager, UserRoles.Admin, UserRoles.SuperAdmin],
      breadcrumb: 'Home/KMS Portal/Project Content/Add Project',
    }
  },
  {
    path: 'Home/KMSPortal/Project Content/AddProj',
    component: IctProjectDetailComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', UserRoles.Viewer, UserRoles.ContentManager, UserRoles.Admin, UserRoles.SuperAdmin],
      breadcrumb: 'Home/KMS Portal/Project Content/Add Project',
    }
  },
  {
    path: 'Home/KMSPortal/Search/:searchterm',
    component: SearchpageComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership'],
      breadcrumb: 'Home/KMS Portal/Search',
    }
  },
  {
    path: 'Home/KMSPortal/:speciality/editProject/:id',
    component: ProjectDetailComponent,
    canActivate: [AuthGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', UserRoles.ContentManager, UserRoles.Admin, UserRoles.SuperAdmin],
      breadcrumb: 'Home/KMS Portal/:speciality/Edit Project',
      preload: true,
    }
  },
  {
    path: 'Home/Artifactory/:selectedtemplate',
    component: TemplateDocsComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      breadcrumb: 'Home/Artifactory Repository/:selectedtemplate',
      roles: ['SuperAdmin', 'Admin', 'Leadership', 'CompetencyLeader', 'SubCompetencyLeader'],
    }
  },
  {
    path: 'Home/Artifactory',
    component: TemplatesComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', 'CompetencyLeader', 'SubCompetencyLeader'],
      breadcrumb: 'Home/Artifactory Repository',
      preload: true
    }
  },
  {
    path: 'Home/Artifactory Repository',
    component: TemplatesComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', 'CompetencyLeader', 'SubCompetencyLeader'],
      breadcrumb: 'Home/Artifactory Repository',
      preload: true
    }
  },
  {
    path: 'Home/proposalaccelerators',
    component: QuestionExportComponent,
    canActivate: [AuthGuard],
    data: {
      breadcrumb: 'Home/proposal accelerators'
    }
  },
  {
    path: 'Home/KMSPortal',
    loadChildren: () => import('./views/ict-project/ict-projects.module').then(m => m.IctProjectsModule),
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', UserRoles.SuperAdmin, UserRoles.ContentManager, UserRoles.Admin,]
    }
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent
  },
  // {
  //   path: 'searchict',
  //   component: IctsearchpageComponent,
  //   canActivate: [AuthGuard]
  // },
  {
    path: 'users',
    loadChildren: () => import('./views/users/user.module').then(m => m.UsersModule),
    canActivate: [RoleGuardGuard],
    data: {
      roles: [UserRoles.SuperAdmin, UserRoles.Admin],
      preload: true
    },
  },
  {
    path: 'project',
    loadChildren: () => import('./views/projects/projects.module').then(m => m.ProjectsModule),
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', UserRoles.ContentManager, UserRoles.Admin, UserRoles.SuperAdmin],
      preload: true
    },
  },

  {
    path: 'Home/Competencies',
    loadChildren: () => import('./views/competencies/competencies.module').then(m => m.CompetenciesModule),
    canActivate: [AuthGuard],

  },
  {
    path: 'Home/dataupload',
    component: DataUploadComponent,
    canActivate: [RoleGuardGuard],
    data: {
      roles: ['SuperAdmin'],
      preload: true,
      breadcrumb: 'Home/Employee Data Import/'
    }
  },
  {
    path: 'Home/mockups',
    component: MockupsComponent,
    canActivate: [RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'Leadership', 'CompetencyLeader', 'SubCompetencyLeader'],
      preload: true
    }
  },

  {
    path: 'Home/employeedata',
    component: EmployeeDataTableComponent,
    canActivate: [RoleGuardGuard],
    data: {
      roles: ['SuperAdmin'],
      preload: true,
      breadcrumb: 'Home/Employee Data Export/'
    },
  },
  {
    path: 'Home/Missing-mandatory-fields',
    component: FieldMissingEmployeesComponent,
    canActivate: [RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'CompetencyLeader', 'SubCompetencyLeader'],
      preload: true,
      breadcrumb: 'Home/Employee Competency Assignment/'
    },
  },
  {
    path: 'Home/Compliance',
    component: OrganizationalComplianceComponent,
    canActivate: [RoleGuardGuard],
    data: {
      roles: ['SuperAdmin'],
      preload: true,
      breadcrumb: 'Home/Compliance'
    },
  },
  {
    path: 'Home/Compliance/Add-Compliance',
    component: OrganizationalComplianceCreationComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin'],
      breadcrumb: 'Home/Compliance/Add-Compliance'
    },
  },
  {
    path: 'Home/Compliance/edit/:id',
    component: OrganizationalComplianceCreationComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin'],
      breadcrumb: 'Home/Compliance/edit'
    },
  },
  {
    path: 'Home/Compliance/view/:id',
    component: OrganizationalComplianceCreationComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin'],
      breadcrumb: 'Home/Compliance/view'
    },
  },
  {
    path: 'Home/projectdata',
    component: ProjectDataTableComponent,
    canActivate: [RoleGuardGuard],
    data: {
      roles: ['SuperAdmin'],
      preload: true,
      breadcrumb: 'Home/Project Tech Stack Data/'
    },
  },
  {
    path: 'Home/Missing-mandatory-fields',
    component: FieldMissingEmployeesComponent,
    canActivate: [RoleGuardGuard],
    data: {
      roles: ['SuperAdmin'],
      preload: true,
      breadcrumb: 'Home/Employee Competency Assignment/'
    },
  },
  {
    path: 'gpltrnqwbxzykjasfcedvuihm',
    loadChildren: () => import('./views/project-connects/project-connects.module').then(m => m.ProjectConnectsModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'Home/employee',
    component: EmployeeComponent,
  },

  {
    path: `Home/Competencies/:competency/:subcompetency/Resources/:filter`,
    component: SkillRepoEmployeesComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Leadership', 'CompetencyLeader', 'SubCompetencyLeader'],
      preload: true,
      breadcrumb: 'Home/Competencies/:competency/:subcompetency/Resources/:filter'
    }
  },
  {
    path: `Home/CMF Portal/:competency/:subcompetency/Resources/:filter`,
    component: SkillRepoEmployeesComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Leadership', 'CompetencyLeader', 'SubCompetencyLeader'],
      preload: true,
      breadcrumb: 'Home/CMF Portal/:competency/:subcompetency/Resources/:filter'
    }
  },
  {
    path: `Home/Competencies/:competency/:subcompetency/Certificates/:filter`,
    component: SkillRepoEmployeesComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Leadership', 'CompetencyLeader', 'SubCompetencyLeader'],
      preload: true,
      breadcrumb: 'Home/Competencies/:competency/:subcompetency/Certificates/:filter'
    }
  },
  {
    path: `Home/CMF Portal/:competency/:subcompetency/Certificates/:filter`,
    component: SkillRepoEmployeesComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      roles: ['SuperAdmin', 'Leadership', 'CompetencyLeader', 'SubCompetencyLeader'],
      preload: true,
      breadcrumb: 'Home/CMF Portal/:competency/:subcompetency/Certificates/:filter'
    }
  },
  {
    path: 'Home/CMF Portal',
    loadChildren: () => import('./views/competencies/competencies.module').then(m => m.CompetenciesModule),
    canActivate: [AuthGuard],
    data: {
      roles: ['SuperAdmin', 'Admin', 'CompetencyLeader', 'SubCompetencyLeader'],
      preload: true
    }
  },
  {
    path: 'Home/Customer360',
    component: Customer360DashboardComponent,
    data: {
      breadcrumb: 'Home/Customer360'
    }
  },
  {
    path: 'Home/ProjectTechStack',
    component: ProjectTechstackComponent,
    canActivate: [AuthGuard],
    data: {
      roles: ['SuperAdmin'],
      preload: true,
      breadcrumb: 'Home/Project Tech Stack'
    }
  },
  {
    path: 'Home/Dashboard/Program Description/:id',
    component: ProgramDescriptionComponent,
    data: {
      breadcrumb: 'Home/Dashboard/Program Description',
      preload: true
    },
  },
  {
    path: 'Home/Dashboard/Team Program Details',
    component: TeamProgramComponent,
    data: {
      breadcrumb: 'Home/Dashboard/Team Program Details',
      preload: true
    },
  },
  {
    path: 'Home/employee-career/employee-Career-path/program-catalogue/:id',
    component: ProgramDescriptionComponent,
    data: {
      breadcrumb: 'Home / Dashboard / Employee Career Path / Program Catalogue / Program Description',
      preload: true
    },
  },
  {
    path: 'Home/Dashboard/Program Catalogue',
    component: ProgramCatalogueComponent,
    data: {
      breadcrumb: 'Home / Dashboard / Program Catalogue ',
      preload: true
    },
  },
  {
    path: 'Home/Dashboard/Employee Career Path/Program Catalogue',
    component: ProgramCatalogueComponent,
    data: {
      breadcrumb: 'Home / Dashboard / Employee Career Path / Program Catalogue ',
      preload: true
    },
  },
  {
    path: 'Home/employee-career/program-catalogue/:id',
    component: ProgramDescriptionComponent,
    data: {
      breadcrumb: 'Home / Dashboard / Program Catalogue / Program Description',
      preload: true
    },
  },
  {
    path: 'Home/Dashboard/Employee Career Program',
    component: EmployeeCareerProgramComponent,
    data: {
      breadcrumb: 'Home/ Dashboard / Employee Career Program',
      preload: true
    },
  },
  {
    path: 'Home/Dashboard/Employee Career Program/Program Catalogue',
    component: EmployeeCareerProgramComponent,
    data: {
      breadcrumb: 'Home/ Dashboard / Employee Career Program/ Program Catalogue ',
      preload: true
    },
  },
  {
    path: 'Home/Dashboard/Employee Career Path',
    component: EmployeeCareerPathComponent,
    data: {
      breadcrumb: 'Home / Dashboard / Employee Career Path ',
      preload: true
    },
  },
  {
    path: 'maintenance',
    component: MaintenancePageComponent,
  },
  {
    path: 'Audit',
    component: ProjectDisplayComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      breadcrumb: 'Audit',
      // roles:['SuperAdmin'],
      preload: true
    },
  },

  {
    path: 'Home/Audit/Audit Overview/:id',
    component: QuestionsTableComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      // roles:['SuperAdmin','Skill.Admin'],
      preload: true,
      breadcrumb: 'Home/Audit/Audit Overview/:id'
    }
  },
  {
    path: 'Home/Audit/CreateAudit',
    component: AuditorDetailsComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      breadcrumb: 'Home/Audit/Create Audit',
      // roles:['SuperAdmin'],
      preload: true
    },
  },
  {
    path: 'Home/Audit/Select Categories',
    component: SelectCategoriesComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      breadcrumb: 'Home/Audit/Select Categories',
      // roles:['SuperAdmin'],
      preload: true
    },
  },
  {
    path: 'Home/Audit/Auditor Detail/Audit Overview/:id',
    component: AuditorDetailsComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      breadcrumb: 'Home/Audit/Audit Overview/More Audit Details',
      // roles: ['SuperAdmin'],
      preload: true
    },
  },

  {
    path: 'Home/Audit/Auditor Detail/Audit Overview',
    component: ProjectOverviewComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      breadcrumb: 'Home/Audit/Auditor Detail/Audit Overview',
      // roles:['SuperAdmin'],
      preload: true
    },
  },
  {
    path: 'Home/Audit/Auditor Detail/Audit Overview/:id',
    component: AuditorDetailsComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      breadcrumb: 'Home/Audit/Audit Overview',
      // roles: ['SuperAdmin'],
      preload: true
    },
  },

  {
    path: 'Home/Audit/Auditor Detail/Audit Overview',
    component: ProjectOverviewComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      breadcrumb: 'Home/Audit/Auditor Detail/Audit Overview',
      // roles:['SuperAdmin'],
      preload: true
    },
  },
  {
    path: 'Home/Audit/Audit Overview',
    component: ProjectOverviewComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      breadcrumb: 'Home/Audit/Audit Overview',
      // roles:['SuperAdmin'],
      preload: true
    },
  },
  {
    path: 'Home/Audit',
    component: ProjectDisplayComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      breadcrumb: 'Home/Audit',
      // roles:['SuperAdmin'],
      preload: true
    },
  },
  {
    path: 'Home/Proof Of Concepts',
    component: GenAiMainComponent,
    canActivate: [AuthGuard,RoleGuardGuard],
    data:{
      breadcrumb: 'Home/Proof Of Concepts', 
      roles:['Skill.User','Admin','SuperAdmin','Leadership','CompetencyLeader', 'SubCompetencyLeader'],
      preload: true
    },
  },
  {
    path: 'Home/MasterQuestion',
    component: QuestionMasterComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      breadcrumb: 'Home/MasterQuestion',
      roles: ['SuperAdmin'],

    },
  },
  {
    path: 'Home/TechnologyQuestions',
    component: TechnologyQuestionsComponent,
    canActivate: [AuthGuard, RoleGuardGuard],
    data: {
      breadcrumb: 'Home/TechnologyQuestions',
      // roles:['SuperAdmin'],

    },
  },
  {
    path: 'projects',
    component: ProjectListingComponent,
  },
  {
    path: 'project-settings',
    component: ProjectSettingsComponent,
  },

  { path: '**', redirectTo: 'Dashboard', pathMatch: 'full' },

];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: AppPreloadingStrategy }),
  ],
  exports: [RouterModule],
  providers: [AppPreloadingStrategy]
})

export class AppRoutingModule { }